/* eslint-disable react/self-closing-comp */
import React from "react";
import { Page } from "components/core/Page";
import Container from "components/core/Page/Container";
import { H1 } from "components/core/Typography";
import { ScrollToTop } from "components/core/ScrollToTop";
import {
	DescriptionParagraph,
	MailingAddress,
	PhoneAndEmail,
	MailButton
} from "components/sdc/ContactUs";
import { useSelector } from "react-redux";
import "./ContactUsPage.scss";

function ContactUsPage() {
	const baseUrl = useSelector((state) => state?.app?.baseUrl);
	return (
		<Page
			title="Contact Storage.com about self storage services"
			description=""
			canonical={`${baseUrl}/help/contact/`}
		>
			<Container>
				<div className="sdc-page-container">
					<div className="contact-us">
						<H1>Contact Storage.com</H1>
						<DescriptionParagraph />
						<MailingAddress />
						<PhoneAndEmail />
						<MailButton />
					</div>
				</div>
			</Container>
			<ScrollToTop />
		</Page>
	);
}

export default ContactUsPage;
